<template>
  <div
    :class="['rh-booking', inline ? 'rh-booking-inline' : 'rh-booking-modal']"
    role="dialog"
    :aria-modal="inline ? undefined : 'true'"
    aria-label="Бронирование"
    @click.self="!inline && emit('close')"
  >
    <div class="rh-booking-panel">
      <button
        type="button"
        class="rh-booking-close"
        :aria-label="inline ? 'Назад к списку' : 'Закрыть'"
        @click="emit('close')"
      >
        <template v-if="inline">← Назад к списку</template>
        <template v-else>×</template>
      </button>

      <div v-if="!loaded" class="rh-booking-loading">
        <span class="rh-spinner" aria-label="Загрузка" />
      </div>
      <iframe
        class="rh-booking-frame"
        :src="url"
        title="Бронирование"
        allow="payment; clipboard-write"
        referrerpolicy="strict-origin-when-cross-origin"
        :style="frameStyle"
        @load="loaded = true"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';

const props = defineProps<{
  url: string;
  inline: boolean;
  height: number | null;
}>();

const emit = defineEmits<{ close: [] }>();

const loaded = ref(false);

// inline: высоту отдаёт сама страница серча (postMessage resize); пока её нет —
// разумный минимум, чтобы не прыгал экран.
const frameStyle = computed(() =>
  props.inline
    ? { height: `${Math.max(props.height ?? 0, 560)}px` }
    : undefined,
);

function onKeydown(event: KeyboardEvent): void {
  if (event.key === 'Escape') emit('close');
}

let previousOverflow = '';

onMounted(() => {
  if (props.inline) return;
  // Окно перекрывает страницу хоста — гасим её прокрутку, пока оно открыто.
  previousOverflow = document.body.style.overflow;
  document.body.style.overflow = 'hidden';
  document.addEventListener('keydown', onKeydown);
});

onBeforeUnmount(() => {
  if (props.inline) return;
  document.body.style.overflow = previousOverflow;
  document.removeEventListener('keydown', onKeydown);
});
</script>
